module.exports = __webpack_public_path__ + "img/veggie_lasagna.657aae73.jpg";